/**
 * Join-window hydrate + scroll-up history for chat / Q&A / announcements.
 */

export const COLLAB_PAGE_SIZE = 50;

export type CollabPage<T> = {
  items: T[];
  hasMore: boolean;
};

export type CollabPageQuery = {
  since?: string;
  before?: string;
  limit?: number;
};

export function joinedSinceIso(room?: {
  localParticipant?: { joinedAt?: Date | number | string | null };
} | null): string {
  const at = room?.localParticipant?.joinedAt;
  if (at != null) {
    const d = at instanceof Date ? at : new Date(at);
    if (!Number.isNaN(d.getTime())) return d.toISOString();
  }
  return new Date().toISOString();
}

export function mergeOlderById<T>(
  older: T[],
  current: T[],
  idOf: (row: T) => string,
): T[] {
  const seen = new Set(
    current.map(idOf).map((id) => String(id || "").trim()).filter(Boolean),
  );
  const prepend = older.filter((row) => {
    const id = String(idOf(row) || "").trim();
    return Boolean(id) && !seen.has(id);
  });
  return [...prepend, ...current];
}

export function oldestCreatedAt<T extends { created_at?: string | null; pinned?: boolean }>(
  items: T[],
  fallback?: string,
): string | undefined {
  const src = items.filter((row) => !row.pinned && row.created_at);
  let min: string | undefined;
  let minMs = Infinity;
  for (const row of src) {
    const iso = String(row.created_at || "");
    const ms = Date.parse(iso);
    if (!Number.isNaN(ms) && ms < minMs) {
      minMs = ms;
      min = iso;
    }
  }
  return min || fallback;
}

export function appendCollabPageParams(
  qs: URLSearchParams,
  page?: CollabPageQuery,
): void {
  if (!page) return;
  if (page.since) qs.set("since", page.since);
  if (page.before) qs.set("before", page.before);
  if (page.limit) qs.set("limit", String(page.limit));
}
